export function veilString(string: string): string {
    let start = 0, end = 0;
    if (string.length >= 16) {
        [start, end] = [4, 2];
    } else if (string.length >= 12) {
        [start, end] = [3, 1];
    } else if (string.length >= 8) {
        [start, end] = [2, 1];
    } else if (string.length >= 6) {
        [start, end] = [2, 0];
    }

    const body = Array.from(Array(string.length - (start + end)), () => '*').join('');

    return string.slice(0, start) + body + (end > 0 ? string.slice(-end) : '');
}
